module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-7f145bd3.png";